import {PlayerBase} from "../../player/player.base";
import {ChangeDetectionStrategy, Component, Injector, ViewChild} from '@angular/core';
import {GenericElm} from '../../player/generic.elm';
import {Observable, of, switchMap, takeUntil, timer} from 'rxjs';
import {catchError, tap} from "rxjs/operators";
import {CachingService} from "../../services/caching/caching.service";


@Component({
  selector: 'app-video',
  template: '<div #component></div>',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoComponent extends PlayerBase {
  @ViewChild('myVideo', {static: true} ) myVideo;
  genericElm: GenericElm;
  resourceId;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        this.genericElm = new GenericElm(this.component);
        this.resourceId = this.data.Resource[0].$.resource;
        return (<CachingService>this.playerService.caching).getResource(this.resourceId);
      }),
      switchMap( path => {
          debugger;
        let aspectRatio = false;
        if (this.data.Resource[0].AspectRatio != null) {
          aspectRatio = this.data.Resource[0].AspectRatio[0].$.maintain == "1";
        }
        let autoRewind = false;
        let volume = 1.0;

        if (this.data.Resource[0].Video != null) {
          autoRewind = this.data.Resource[0].Video[0].$.autoRewind == "1";
          volume = Number(this.data.Resource[0].Video[0].$.volume);
        }
        return this.genericElm.setMedia(path, aspectRatio, this.actualWidth, this.actualHeight, autoRewind, volume).pipe(
          switchMap( a=> this.genericElm.play(false) ),
        )
      }),
      switchMap(v => {
        //this.playerService?.removeLoading(this.constructor.name)
        if (this.genericElm && this.editMode) {
          this.genericElm.stop();
        }
        return of('a');
      }),
      catchError(err => {
          debugger;
          return this.logError(err)
      }),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  stop(): void {
    super.stop();
    this.genericElm.stop();
  }

  addContent(statTag, statField, duration) {
    this.playerService.stats.addContent(statTag, 0, this.resourceId, duration);
  }

  destroy(): void {
    if (this.genericElm != null) {
      this.genericElm.destroy();
    }
    super.destroy();
  }
}
